import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import API_BASE_URL from 'Components/API';
import Loading from "Components/Loading";
import { useTranslation } from "react-i18next";
import { ReactComponent as CalendarIcon } from "Assets/icons/calendar.svg";
import { ReactComponent as DownloadIcon } from "Assets/icons/downloadSlim.svg";
import { ReactComponent as EyeIcon } from "Assets/icons/eyeSlim.svg";
import { ReactComponent as AttachIcon } from "Assets/icons/attach-slim.svg";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
import { ReactComponent as CameraIcon } from "Assets/icons/camera-outline.svg";
import { ReactComponent as FilmIcon } from "Assets/icons/film.svg";
const VisualReports = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, setData] = useState([]);
    useEffect(() => {
        fetchData();
    }, [currentLang]);
    const fetchData = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/Media/GetVisualReports?PageSize=3&PageNumber=1`);
            const data = await response.json();
            setData(data.results || []);
            setIsLoaded(true);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    return (
        <div className="megaMenuContent">
            <div className="row h-100">
                <div>
                    <div className="d-flex justify-content-between align-items-center">
                        <p className="mb-0 fw-bold">{t('latest_published_video_reports') }:</p>
                        <a href="/Media/VisualReports" target="_blank" className="menu-button-width btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1 mb-3" >
                            {t('view_archive') }
                            <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                                {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}   
                            </span>
                        </a>
                    </div>
                    {
                        isLoaded ?
                            <>
                                <div className="row">
                                    {

                                        data.map((Report, index) => (

                                            <div className="col col-4 mb-4" key={Report.id}>
                                                <div className="visual-report-box position-relative text-center">
                                                    <Link to={`/Media/VisualReports/Post/${Report.id}`} className="mb-3 text-center d-block">
                                                        <div className="custom-image-layout">
                                                            {Report.thumbnails && Report.thumbnails.length > 0 && (
                                                                <>
                                                                    {/* Right column: first thumbnail */}
                                                                    <div className="right-image">
                                                                        {Report.thumbnails[0] && (
                                                                            <img
                                                                                src={`data:${Report.thumbnails[0].contentType};base64,${Report.thumbnails[0].fileContent}`}
                                                                                className="img-right"
                                                                                alt=""
                                                                            />
                                                                        )}
                                                                    </div>

                                                                    {/* Left column: second and third thumbnails */}
                                                                    <div className="left-images">
                                                                        {Report.thumbnails[1] && (
                                                                            <img
                                                                                src={`data:${Report.thumbnails[1].contentType};base64,${Report.thumbnails[1].fileContent}`}
                                                                                className="img-left-top"
                                                                                alt=""
                                                                            />
                                                                        )}
                                                                        {Report.thumbnails[2] && (
                                                                            <img
                                                                                src={`data:${Report.thumbnails[2].contentType};base64,${Report.thumbnails[2].fileContent}`}
                                                                                className="img-left-bottom"
                                                                                alt=""
                                                                            />
                                                                        )}
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </Link>

                                                    <h2 className="h4 text-center visual-report-tile mb-3">
                                                        <Link to={`/Media/VisualReports/Post/${Report.id}`}>{Report.title}</Link>
                                                    </h2>
                                                    <div className="visual-report-meta">                                                        
                                                        <div className="slide-actions d-flex justify-content-between align-items-center border-top pt-2">
                                                            <div className="slide-buttons">
                                                                <span className="visual-counts">
                                                                    <CameraIcon /> {Report.imagesCount} {t('photo')}
                                                                </span>

                                                                <span className="visual-counts">
                                                                    <FilmIcon /> {Report.videoesCount} {t('video')}
                                                                </span>
                                                            </div>

                                                            <div className="slider-date">
                                                                {Report.date} <CalendarIcon />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                    
                                </div>
                            </>
                            :
                            <Loading />
                    }
            </div>
            </div>
        </div>
    );
};

export default VisualReports;
